import styled, {css} from 'styled-components';

export const OtpEditWrapper = styled.div(
    props => `
        width: 100%;
        display: flex;
        padding: ${props.theme.spacing.large.l15} ${props.theme.spacing.nospacing};
        border-bottom: 1px solid ${props.theme.colors.black.light1};
    `,
)

export const OtpEmailInnerWrap = styled.div(
    props => `
        width: 50%;
        display: flex;

        @media only screen and (min-width:320px) and (max-width: 767px){
            width: 55%;
        }

        @media only screen and (min-width:1025px) and (max-width: 1300px){
            align-items: center;
        }
    `,
)

export const OtpMobileInnerWrap = styled.div(
    props => `
        width: 50%;
        display: flex;

        @media only screen and (min-width:320px) and (max-width: 767px){
            width: 45%;
        }

        @media only screen and (min-width:1025px) and (max-width: 1300px){
            align-items: center;
        }
    `,
)

export const OtpEditIconWrap = styled.div(
    props => `
        width:4rem;
        height:4rem;
        border-radius:${props.theme.misc.borderRadius.base};
        border: 1px solid ${props.theme.colors.blue.dark};
        align-items: center;
        justify-content: center;
        display: flex;

        @media only screen and (min-width:320px) and (max-width: 767px){
            display: none;
        }
    `,
)

export const OtpEditTextWrap = styled.div(
    props => `
        display: flex;
        width:80%;
        flex-direction: column;
        padding-left: ${props.theme.spacing.base};

        @media only screen and (min-width:320px) and (max-width: 767px){
            padding-left: ${props.theme.spacing.nospacing};
            width:100%;
        }
    `,
)

export const OtpEditHeadText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        letter-spacing: ${props.theme.font.letterSpacing.small};
    `,
)

export const OtpEditSubText = styled.span(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.grey.base};
        letter-spacing: ${props.theme.font.letterSpacing.small};
    `,
)

export const OtpEditText = styled.a(
    props => `
        margin-left: ${props.theme.spacing.small.s3};
        font-size: ${props.theme.font.base};
        color: ${props.theme.colors.blue.base};
        cursor: pointer;
        @media only screen and (min-width:320px) and (max-width: 767px){
            margin-left: ${props.theme.spacing.nospacing};
            display: block;
        }
        @media only screen and (min-width:1025px) and (max-width: 1300px){
            margin-left: ${props.theme.spacing.nospacing};
            display: block;
        }
    `,
)

export const OtpInputOuterWrapper = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;s
    `,
)

export const OtpInputInnerWrapper = styled.div(
    props => `
        width:100%;
        display: flex;
        padding-bottom: ${props.theme.spacing.large.l20};
    `,
)

export const OtpInputWrapper = styled.div(
    props => `
        width: 100%;
        display: flex;

    `,
)

export const OtpInputBlock = styled.div(
    props => `
        width: 65%;
        display: flex;
        flex-direction: column;
    `,
)

export const OtpInputLabel = styled.label(
    props => `
        font-size: ${props.theme.font.base};
        color: ${props.theme.colors.black.base};
        text-transform: ${props.theme.font.textTransform.upper};
        font-weight: ${props.theme.font.fontWeight.bold};
    `,
)

export const OtpMainWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        padding-top: ${props.theme.spacing.small.s7};
        padding-bottom: ${props.theme.spacing.small.s2};
    `,
)

export const OtpInput = styled.input(
    props =>`
    width: 4rem;
    height: 4.2rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    margin-right: ${props.theme.spacing.base};
    color: ${props.theme.colors.grey.base};
    border: 1px solid ${props.theme.colors.grey.lightd0};
    background-color: ${props.theme.colors.white.base};
    padding: ${props.theme.spacing.small.s5};
    font-size: ${props.theme.font.large.font18};
    text-align: center;

    ::-webkit-inner-spin-button, 
    ::-webkit-outer-spin-button{
        -webkit-appearance: none;
        margin: ${props.theme.spacing.nospacing};
    }

    @media only screen and (min-width:320px) and (max-width: 767px){
        width: 3.6rem;
        height: 3.6rem;
        margin-right: ${props.theme.spacing.small.s5};
    }
    border-color: ${props.hasError ? props.theme.colors.red.base : ''};
`);


export const ResendBlock = styled.div(
    props => `
        width:35%;
        display: flex;
        padding-top: ${props.theme.spacing.large.l30};

        @media only screen and (min-width:320px) and (max-width: 768px){
            padding-top: ${props.theme.spacing.nospacing};
            justify-content: flex-end;
        }

        @media only screen and (min-width:1025px) and (max-width: 1300px){
            justify-content: flex-end;
        }
    `,
)

export const ResendText = styled.a(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.blue.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        cursor: pointer;
    `,
)


